
export default {
  layout: 'academy_default',
  head() {
    return {
      title: 'Zápis na školení | 3D Fitness Academy'
    }
  },
}
